/* eslint-disable camelcase */
import { User } from 'portal-sdk';

export const getPortalUserTrackingData = ({
  company,
  date_joined,
  email,
  first_name,
  id,
  is_databricks_user,
  last_name,
  title,
  use_case,
}: User) => ({
  cloud_user_id: id,
  company,
  email,
  is_databricks_user,
  name: `${first_name} ${last_name}`,
  signed_up_at: date_joined,
  title,
  use_case,
});
